import { PayloadAction } from "@reduxjs/toolkit";
import { SessionState } from "../session.slice.ts";
import { SubmitContactsPayload } from "../../../actions/submit-contacts.action.ts";

export const submitContactsReducer = (
  state: SessionState,
  action: PayloadAction<SubmitContactsPayload>,
) => {
  state.token = action.payload.token;
  state.isFirstSession = action.payload.isFirstSession;
};
